export default "__VITE_ASSET__H7RlDEmN__"